<template>
  <div class="container top-0 position-relative z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBtn="bg-gradient-success"
          :needLogoWhite="true" />
      </div>
    </div>
  </div>
  <main class="main-content mt-0">
    <div
      class="page-header align-items-start min-vh-50 pt-5 pb-11 m-3 border-radius-lg"
      style="backgroundImage: url('/img/cover-about.52b8f40e.png'); background-position: center;"
    >
      <span class="mask bg-gradient-dark opacity-6"></span>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 text-center mx-auto">
            <h1 class="text-white mb-2 mt-5">En hora buena!
              <!-- {{ $route.params.id }} {{$route.query.test}} -->
              </h1>
            <p
              class="text-lead text-white"
            >Use este formulario para completar su afiliación.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Aceptar Terminos y Adquirir -->
    <div class="container" v-if="this.pagado==false">
      <div class="row mt-lg-n11 mt-md-n11 mt-n10 justify-content-center">
        <div class="col-xl-12 col-lg-5 col-md-7 mx-auto">
          <div class="card z-index-0">
            <div class="row card-body">
              <div class="col-lg-6 col-md-12">
                <h6 class="mt-1 text-addiuva">Datos del Programa</h6>
                <hr class="horizontal dark" />
                <detalle-programa
                  :programa = "programa"
                  :periodicidad = "periodicidad"
                  :inicio = "vigencia.inicio"
                  :fin = "vigencia.fin"
                  :tarifa = "tarifa"
                ></detalle-programa>
              </div>
              <div class="col-lg-6 col-md-12">
                <h6 class="text-addiuva">Datos de los Afiliados</h6>
                <hr class="horizontal dark" />
                <detalle-afiliados
                  :afiliados = "afiliados"
                ></detalle-afiliados>
              </div>
              <!-- Términos y Condiciones -->
              <!-- <div class="col-12">
                <h6 class="text-addiuva">Términos y Condiciones</h6>
                <hr class="horizontal dark" />
                <Checkbox v-model="terminosCheck" :binary="true" /> <span>Declaro que he leído y acepto expresamente las <a href="#" target="_black" class="text-addiuva"><u>Condiciones Generales</u></a> aquí publicadas y que son aplicables a mi compra.</span>
              </div> -->
            </div>
            <div class="card-body">
              <h6 class="text-addiuva">Términos y Condiciones</h6>
                <hr class="horizontal dark" />
              <form role="form">

                <argon-checkbox id="flexCheckDefault" v-model="terminosCheck">
                  <label class="form-check-label" for="flexCheckDefault">
                    Declaro que he leído y acepto expresamente las
                    <a
                      href="#" target="_black"
                      class="text-addiuva font-weight-bolder"
                    >Condiciones Generales</a>
                    aquí publicadas y que son aplicables a mi compra
                  </label>
                </argon-checkbox>
                <div class="text-center">
                  <argon-button fullWidth color="addiuva" variant="gradient" class="my-4 mb-2" @click="pagado=true" :disabled="!this.terminosCheck" >Adquirir</argon-button>
                </div>
                <p class="text-sm mt-3 mb-0">
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Compra Exitosa -->
    <div class="container" v-if="this.pagado==true">
      <div class="row mt-lg-n11 mt-md-n11 mt-n10 justify-content-center">
        <div class="col-xl-12 col-lg-5 col-md-7 mx-auto">
          <div class="card z-index-0">
            <div class="row card-body">
              <div class="mt-4 mb-4">
                <div class="col-md-12 bg-gradient-success shadow text-center border-radius-md p-3">
                  <span class="text-white" style="user-select:none;">
                    <i class="fas fa-check-circle"></i> <span style="font-weight:600;">Compra Exitosa</span>
                  </span>
                </div>
              </div>
              <ul style="padding:1rem 6rem;">
                <li>
                  Si quieres dar de baja el servicio, recuerda que puedes hacerlo contactándote al <a class="text-addiuva" href="tel:77710774" style="font-weight:800;">800 xx xxx.</a>
                </li>
                <li>
                  Recuerda que en caso de necesitar Asistencia, el afiliado deberá comunicarse con nuestra Central de Atencion y proporcionar su nombre completo, número de documento de identidad, teléfono, ubicación y seguir las instrucciones que le imparta el Operador.
                </li>
                <li>
                  En caso de una emergencia el Afiliado deberá SIEMPRE obtener la autorización de la Central de Asistencia, antes de comprometer cualquier gasto en relaciona a los beneficios de su Programa. De lo contrario perderá el derecho de reembolso por cualquier gasto realizado unilateralmente.
                </li>
              </ul>
              <documentos-generados
                :certificado = "certificado"
                :afiliados = "afiliados"
                :factura = "factura"
              ></documentos-generados>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <app-footer />
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import ArgonCheckbox from "@/components/ArgonCheckbox.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import DetallePrograma from "./components/DetallePrograma.vue";
import DetalleAfiliados from "./components/DetalleAfiliados.vue";
import DocumentosGenerados from "./components/DocumentosGenerados.vue";
// import Checkbox from 'primevue/checkbox';
import axios from 'axios';
import authHeader from '../services/auth-header';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "signin",
  components: {
    Navbar,
    AppFooter,
    ArgonCheckbox,
    ArgonButton,
    DetallePrograma,
    DetalleAfiliados,
    DocumentosGenerados
    // Checkbox
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      code_afiliacion: this.$route.params.id,
      pagado: true,
      certificado: './certificado',
      factura: "/factura.url",
      programa: 'Vehicular',
      tarifa: 25.50,
      periodicidad: 'Mensual',
      afiliados: [
        {
          nombres: 'Jhon M',
          apellidos: 'Doe',
          dob: '1988-04-14',
          edad: '35',
          documento: '123456789LP',
          telefono: '59177789887',
          email: 'jjpere1@gmail.com',
        },
        {
          nombres: 'Mary A',
          apellidos: 'Smith',
          dob: '1988-04-14',
          edad: '35',
          documento: '123456789LP',
          telefono: '59177789887',
          email: 'jjpere1@gmail.com',
        },
      ],
      vigencia: {
        inicio: new Date().toJSON().slice(0, 10),
        fin: new Date().toJSON().slice(0, 10)
      },
      terminosCheck: false
    }
  },
  methods: {
    getAfiliationData(){
      let url = this.API_URL + "/afiliaciones/" + this.code_afiliacion;
      axios({
        url: url,
        method: 'get',
        headers: authHeader(),
      })
      .then(response => {
        console.log('response', response)
        if (response.data.status) {
          let info = response.data.data[0];
          this.pagado = false;
          this.certificado = './certificado';
          this.factura = "/factura.url";
          this.programa = info.nombre_programa;
          this.tarifa = info.tarifa;
          this.periodicidad = info.nombre_periodo;
          let aAfiliados = [];
          info.afiliados.forEach(afiliado => {
            aAfiliados.push({
              codigo_certificado: afiliado.codigo_certificado,
              nombres: afiliado.nombres,
              apellidos: afiliado.apellidos,
              dob: afiliado.fecha_nacimiento,
              edad: afiliado.edad,
              documento: afiliado.numero_documento,
              telefono: afiliado.telefono,
              email: afiliado.email
            });
          });
          this.afiliados = aAfiliados;
          this.vigencia.inicio = info.fecha_inicio
          this.vigencia.fin = info.fecha_fin
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
    this.getAfiliationData();
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
